export const sitemapSelector = (state) => state.sitemap.sitemap;
export const hasSitemapSelector = (state) =>
  !!state.sitemap.sitemap && Object.keys(state.sitemap.sitemap).length !== 0;



// WEBPACK FOOTER //
// ./src/selectors/sitemap.js